<div style="margin: auto;" class="my-12 p-12">
  <h1 style="text-align:center"><b>{{"MODULOES.main.WELCOME_LDD" | translate}}</b></h1>

  <div style="margin: auto; min-width:300px;max-width: 350px;" class="mat-card p-24 mat-elevation-z5">
      <div  style="width: 100%">
        <div style="font-size: 1.6rem; text-align: center" class="pb-24 pt-16">
          {{'APP.ENTER_ORG_NAME_COMPLAINT' | translate}}
        </div>
        <app-suggest-input [formGroup]="tenantForm" controlName="tenantName"
            [suggestService]="tenantByNameService"
            (itemChange)="updateTenants($event)"
            [label]=""
            [placeholder]="'APP.ENTER_ATLEAST_3_LETTERS'|translate"
            [iconPassword]="true">
          </app-suggest-input>
      </div>
  </div>   
    
  <br>

  <div class="my-8" ngClass.gt-sm="px-80" ngClass.lt-sm="px-16">
    <p>{{"APP.LANDING_MESSAGE_COMPLAINT" | translate}}</p>
  </div>

  <div fxLayout="row wrap"  ngClass.gt-sm="px-80" ngClass.lt-sm="px-16">
    <div class="card m-4" fxFlex="49%" *ngFor="let data of contents">
      <div class="card-preview" fxlayout="column" *ngIf="data.contentTypeId == 1">
          <div class="fuse-card" style="max-width:100%!important; min-height: 180px;" [ngStyle.gt-sm]="'max-height: 180px;'">
                  <div class="p-20" fxlayout="row" fxlayoutalign="space-between center" ng-reflect-fx-layout="row" ng-reflect-fx-layout-align="space-between center" style="flex-direction: row; box-sizing: border-box; display: flex;">
                    <div style="align-self: baseline;" class="w-80 h-80 pr-16">
                      <img class="ng-tns-c57-55" [src]="data.thumbnailFile.url" *ngIf="data.thumbnailFile?.url"> 
                      <!--*ngIf="data.thumbnailFile.mimeType == 'image/png' || data.thumbnailFile.mimeType == 'image/jpeg'"-->
                      
                      <!-- <button mat-raised-button class="m-4" *ngIf="!data.thumbnailFile?.url && data.mediaFile?.url">
                        <mat-icon class="secondary-text s-32 mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">play_circle_outline</mat-icon>  ; place-content: center space-between; align-items: center;
                      </button> -->
                    </div>  
                    <div>
                          <!-- <div class="h4 secondary-text">{{data.header}}</div> -->
                          <div class="h1 p-8">{{data.title}}</div>
                          <div [innerHtml]="data.body"></div> <!-- style="display:flex;justify-content:space-between" -->
                      </div>
                     
                  </div>
          </div>
      </div>
    </div>
  </div>

</div>